"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = hyphenateProperty;

var _hyphenateStyleName = require("hyphenate-style-name");

var _hyphenateStyleName2 = _interopRequireDefault(_hyphenateStyleName);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function hyphenateProperty(property) {
  return (0, _hyphenateStyleName2["default"])(property);
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/fela-plugin-fallback-value/node_modules/css-in-js-utils/lib/hyphenateProperty.js
// module id = 901
// module chunks = 0